import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import MaterialSymbol from '../MaterialSymbol';
import FooterColumnHeading from './FooterColumnHeading';

const ACCORDION_SX = {
    bgcolor: 'transparent',
    backgroundImage: 'none',
    boxShadow: 'none',
    borderBottom: '1px solid',
    borderColor: 'grey.200',
    '&:before': { display: 'none' },
    '&.Mui-expanded': { margin: 0 },
    '&:last-of-type': { borderBottom: 'none' },
};

const SUMMARY_SX = {
    minHeight: 44,
    px: 0,
    bgcolor: 'transparent',
    '&.Mui-expanded': { minHeight: 44 },
    '& .MuiAccordionSummary-content': {
        my: 1.25,
        '&.Mui-expanded': { my: 1.25 },
    },
};

const DETAILS_SX = {
    px: 0,
    pt: 0,
    pb: 1.5,
};

function FooterAccordionPanel({ heading, testId, children }) {
    return (
        <Accordion sx={ACCORDION_SX} elevation={0} disableGutters square data-testid={testId}>
            <AccordionSummary
                expandIcon={<MaterialSymbol name="expand_more" size={20} />}
                sx={SUMMARY_SX}
                data-testid={`${testId}-summary`}
            >
                <FooterColumnHeading mb={0}>{heading}</FooterColumnHeading>
            </AccordionSummary>
            <AccordionDetails sx={DETAILS_SX}>
                {children}
            </AccordionDetails>
        </Accordion>
    );
}

FooterAccordionPanel.propTypes = {
    heading: PropTypes.string.isRequired,
    testId: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

export default FooterAccordionPanel;
